import { 
  社会保険入力データ,
  社会保険出力データ,
  calculate月間介護保険料,
  calculate年間労災保険料,
  calculate月間雇用保険料,
  calculate月間子育て支援金,
  calculate月間健康保険料,
  calculate月間年金保険料,
} from "./types"

import { calculateAge } from "../utils/ageCalc";


// =============================================================================
// main関数
// =============================================================================
export function calculate社会保険料(input: 社会保険入力データ): 社会保険出力データ{
  // 判定対象月の「末日」時点の年齢で判定する場合（雇用保険・年金など）
  const 月末日 = new Date(input.対象年, input.対象月, 0).getDate();
  const 末日年齢 = calculateAge(
    input.対象年, input.対象月, 月末日,
    input.生年月日_年, input.生年月日_月, input.生年月日_日
  );

  // 判定対象月の「1日」時点の年齢で判定する場合（介護保険 第1号など）
  const 初日年齢 = calculateAge(
    input.対象年, input.対象月, 1,
    input.生年月日_年, input.生年月日_月, input.生年月日_日
  );

  const 月間年金保険料 = calculate月間年金保険料(
    末日年齢,
    input.年金被保険者区分,
    input.標準報酬月額,
    input.年金保険情報.厚生年金本人負担率,
    input.年金保険情報.国民年金月額,
  );

  const 月間健康保険料 = calculate月間健康保険料(
    input.健康保険被保険者区分,
    input.標準報酬月額, // 会社員用
    input.前年の合計所得,
    input.健康保険情報.健康保険料率,
    input.健康保険情報.国保_均等割額,
    input.健康保険情報.国保_所得割率,
  );  
  
  const { 月間介護保険料 } = calculate月間介護保険料(
    初日年齢,
    input.健康保険被保険者区分,
    input.介護保険情報.医療保険に加入しているか,
    input.介護保険情報.判定月の月末時点で日本に住民票があるか,
    input.介護保険情報.適用除外施設に入所しているか,
    input.介護保険情報.標準報酬月額,
    input.介護保険情報.労使折半する前の介護保険料率,
    input.介護保険情報.市区町村ごとの基準額,
    input.介護保険情報.所得段階ごとの乗数,
  );

  const 月間雇用保険料 = calculate月間雇用保険料(
    input.雇用保険情報.社長や役員等のような雇う側かどうか,
    input.雇用保険情報.is週20時間以上かつ31日以上の雇用見込み,
    input.雇用保険情報.残業代_通勤交通費_各種手当などをすべて足した対象月の実際の総支給額,
    input.雇用保険情報.事業種別,
  );

  const 年間労災保険料 = !input.労災保険情報.特別加入制度に加入している
    ? 0
    : calculate年間労災保険料(input.労災保険情報.給付基礎日額, input.労災保険情報.労災保険料);
  
  const 月間子育て支援金 = calculate月間子育て支援金(
    input.標準報酬月額,
    input.健康保険被保険者区分,
    末日年齢,
    input.対象年,
  );

  return {
    月間健康保険料,
    月間年金保険料,
    月間介護保険料,
    月間雇用保険料,
    年間労災保険料,
    月間子育て支援金,
    月間本人負担合計: 月間健康保険料 + 月間年金保険料 + 月間介護保険料 + 月間雇用保険料 + 月間子育て支援金,
    年間本人負担合計: 年間労災保険料,
  };
}
